import Component from '@glimmer/component';
import type { Signature as DropdownSignature } from 'ui-kit/components/dropdown';
import {
  findValidIdentityDocument,
  groupValidIdentityDocumentsByLevel,
  type ValidIdentityDocument
} from 'parog-web/utils/valid-identity-documents';

interface Signature {
  Args: {
    dropdown: DropdownSignature['Blocks']['default'][0];
    validIdentityDocuments: readonly ValidIdentityDocument[] | undefined;
    recordedCode?: string;
  };
}

/**
 * The items of a valid identity document dropdown: the high group, then the
 * low group. See docs/specs/features/valid-identity-documents.md.
 */
export default class ValidIdentityDocumentItemsComponent extends Component<Signature> {
  /**
   * A recorded code that is not in the list any more (for example after a
   * data fix by the support) is still shown, with its code as label.
   */
  get unlistedRecordedCode(): string | undefined {
    const { recordedCode, validIdentityDocuments } = this.args;
    if (
      !recordedCode ||
      findValidIdentityDocument(validIdentityDocuments, recordedCode)
    ) {
      return undefined;
    }
    return recordedCode;
  }

  get validIdentityDocumentsByLevel() {
    return groupValidIdentityDocumentsByLevel(this.args.validIdentityDocuments);
  }

  <template>
    <@dropdown.Divider @label='Haut degré de confiance' />

    {{#each this.validIdentityDocumentsByLevel.high as |document|}}
      <@dropdown.Item @key={{document.code}} @value={{document.label}} />
    {{/each}}

    <@dropdown.Divider @label='Bas degré de confiance' />

    {{#each this.validIdentityDocumentsByLevel.low as |document|}}
      <@dropdown.Item @key={{document.code}} @value={{document.label}} />
    {{/each}}

    {{#if this.unlistedRecordedCode}}
      <@dropdown.Item
        @key={{this.unlistedRecordedCode}}
        @value={{this.unlistedRecordedCode}}
      />
    {{/if}}
  </template>
}
